import { render, staticRenderFns } from "./BrandingTab.vue?vue&type=template&id=1f43b64b&scoped=true"
import script from "./BrandingTab.vue?vue&type=script&lang=js"
export * from "./BrandingTab.vue?vue&type=script&lang=js"
import style0 from "./BrandingTab.vue?vue&type=style&index=0&id=1f43b64b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f43b64b",
  null
  
)

export default component.exports